
import CyanPageWrapper, { defineComponent, IonPage } from '@/components/CyanPageWrapper.vue'
import TerritoryPicker from '@/components/TerritoryPicker.vue';
import MapaSv from '@/components/MapaSv.vue';

export default defineComponent({
  name: "PickDeptoMpio",
  components: {
    TerritoryPicker,
    IonPage,
    MapaSv,
    CyanPageWrapper
  },
  computed: {},
  methods: {}
});
